var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPopulationIcon = function SvgPopulationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#fff",
    rx: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB1616",
    d: "M20.271 19.543c0-2.812-2.288-5.1-5.1-5.1a5.107 5.107 0 0 0-5.1 5.1c0 2.812 2.288 5.1 5.1 5.1s5.1-2.288 5.1-5.1Zm-5.1 5.1a6.565 6.565 0 0 0-6.558 6.558v1.457c0 .403.326.729.729.729H21a.728.728 0 0 0 .729-.729v-1.457a6.565 6.565 0 0 0-6.558-6.558Zm16.758-10.93c0-2.811-2.288-5.1-5.1-5.1a5.107 5.107 0 0 0-5.1 5.1c0 2.813 2.288 5.101 5.1 5.101s5.1-2.288 5.1-5.1Zm-5.1 5.101a6.565 6.565 0 0 0-6.558 6.558v1.457c0 .403.326.729.729.729h11.658a.728.728 0 0 0 .729-.729v-1.457a6.565 6.565 0 0 0-6.558-6.558Z"
  })));
};
export default SvgPopulationIcon;